import React from 'react';
import GlyphAtom from './GlyphAtom';

export interface IconOrGlyphProps {
  /**
   * A PrimeIcons class (`pi pi-tag`) or an Iconify name (`lucide:tag`). An Iconify name renders
   * through `GlyphAtom` from the offline-bundled collection, the same rule `TagAtom` applies to its
   * `icon`, so a host can hand over the icon a design was drawn with instead of the nearest
   * PrimeIcon.
   */
  icon: string;
  className?: string;
}

/** A decorative icon slot that accepts either icon vocabulary. Always hidden from assistive tech:
 * every caller renders it beside a text label that already says what the icon means. */
const IconOrGlyph: React.FC<IconOrGlyphProps> = ({ icon, className = '' }) =>
  icon.includes(':') ? (
    <GlyphAtom glyph={icon} className={className} aria-hidden />
  ) : (
    <i className={`${icon} ${className}`.trim()} aria-hidden="true" />
  );

IconOrGlyph.displayName = 'IconOrGlyph';

export default IconOrGlyph;
